import React, { useEffect, useState } from "react";

import { Button } from "../ui";
import DetailModal from "../ui/DetailModal";
import FormCustomer from "./FormCustomer";

const Form = (props) => {
    const [form, setForm] = useState("formsPage");

    useEffect(() => {
        if (!props.showModal) {
            setTimeout(() => setForm("formsPage"), 200);
        }
    }, [props.showModal]);

    const handleClose = () => props.setShowModal(false);

    const title = form === "addCustomer" ? "Add Customer" : "Add New";

    const actions =
        form === "addCustomer" ? (
            <>
                <Button variant="secondary" size="sm" onClick={() => setForm("formsPage")}>
                    Back
                </Button>
                <Button variant="primary" size="sm" type="submit" form="customer-form">
                    Add Customer
                </Button>
            </>
        ) : null;

    return (
        <DetailModal
            open={props.showModal}
            onClose={handleClose}
            title={title}
            size="md"
            actions={actions}
        >
            {form === "formsPage" && (
                <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
                    {[
                        {
                            icon: "fa-user",
                            color: "#2c7aa0",
                            bg: "#eff6ff",
                            label: "Add Customer",
                            description: "Create a new customer record",
                            onClick: () => setForm("addCustomer"),
                        },
                        {
                            icon: "fa-shopping-cart",
                            color: "#0d9488",
                            bg: "#f0fdfa",
                            label: "Add Sale",
                            description: "Start a new sale or order",
                            onClick: () => {
                                props.setShowModal(false);
                                props.setOpen(true);
                            },
                        },
                    ].map(({ icon, color, bg, label, description, onClick }) => (
                        <button
                            key={label}
                            onClick={onClick}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "1rem",
                                width: "100%",
                                padding: "1rem 1.1rem",
                                background: "#ffffff",
                                border: "1px solid #e2e8f0",
                                borderRadius: "10px",
                                cursor: "pointer",
                                textAlign: "left",
                                transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = color;
                                e.currentTarget.style.boxShadow = `0 0 0 3px ${color}1a`;
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = "#e2e8f0";
                                e.currentTarget.style.boxShadow = "none";
                            }}
                        >
                            <span
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "2.5rem",
                                    height: "2.5rem",
                                    borderRadius: "8px",
                                    background: bg,
                                    color,
                                    fontSize: "1.05rem",
                                    flexShrink: 0,
                                }}
                            >
                                <i className={`fas ${icon}`} />
                            </span>
                            <span style={{ flex: 1, minWidth: 0 }}>
                                <span
                                    style={{
                                        display: "block",
                                        fontWeight: 600,
                                        fontSize: "0.95rem",
                                        color: "#0f172a",
                                    }}
                                >
                                    {label}
                                </span>
                                <span
                                    style={{
                                        display: "block",
                                        fontSize: "0.8rem",
                                        color: "#64748b",
                                        marginTop: "0.1rem",
                                    }}
                                >
                                    {description}
                                </span>
                            </span>
                            <i
                                className="fas fa-chevron-right"
                                style={{ color: "#cbd5e1", fontSize: "0.75rem", flexShrink: 0 }}
                            />
                        </button>
                    ))}
                </div>
            )}

            {form === "addCustomer" && (
                <FormCustomer
                    showModal={props.showModal}
                    setShowModal={props.setShowModal}
                    onSuccess={() => setForm("formsPage")}
                />
            )}
        </DetailModal>
    );
};

export default Form;
